import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { IApplicationState } from '../../../stateManagement/states/applicationState';
import { IAuthenticationDataState } from '../../../stateManagement/states/dataState';
import * as authenticationTypes from '../../types';
import * as fromRoot from '../../../stateManagement/rootReducer';
import { IPortalInfo, MessageType, IMessage} from '../../../shared/types';
import { ToasterService, ToasterConfig, BodyOutputType } from 'angular2-toaster/angular2-toaster';
import { SaveMfaAuthTypeAction, ServerMfaLoginAction, ResendMfaCodeAction } from 'app/stateManagement/actions/data/authentication';


@Component({
  selector: 'tr-mfaauthentication-container',
  templateUrl: './mfaauthentication-container.component.html',
  //styleUrls: ['./mfaauthentication-container.component.scss']
})

export class MfaauthenticationContainerComponent implements OnDestroy {
  subscriptions: Array<Subscription> = [];
  mfaAuthCodeType: authenticationTypes.IMfaAuthCodeType;
  //portalInfo: IPortalInfo;

  isBusy$: Observable<boolean>;
  message$: Observable<IMessage>;
  isMfaEnabled$: Observable<boolean>;
  isMfaAuthenticated$: Observable<boolean>;
  mfaAuthSetup$: Observable<authenticationTypes.IMfaAuthSetup>;
  currentAccount$: Observable<authenticationTypes.IAccount>;
  portalInfo$: Observable<IPortalInfo>;
  
  
  constructor(
    private store: Store<IApplicationState>,
    private router: Router
  ) {
    this.isBusy$ = this.store.select(fromRoot.isApplicationBusy);
    this.message$ = this.store.select(fromRoot.getAuthenticationStatus);
    this.isMfaEnabled$ = this.store.select(fromRoot.getAuthenticationIsMFAEnabled);
    this.isMfaAuthenticated$ = this.store.select(fromRoot.getAuthenticationIsMFAAuthenticated);
    this.mfaAuthSetup$ = this.store.select(fromRoot.getAuthenticationMFAAuthSetup);
    this.currentAccount$ = this.store.select(fromRoot.getAuthenticationAccount);
    this.portalInfo$ = this.store.select(fromRoot.getApplicationPortalInformation);
    
    this.subscriptions.push(
      this.store.select(fromRoot.getAuthenticationDataState)
        .subscribe((state: IAuthenticationDataState) => {
          if (state.isAuthenticated) {
            this.router.navigate(['/']);
          }
        })
    );

    this.subscriptions.push(
      this.store.select(fromRoot.getAuthenticationMFAAuthCodeType)
        .subscribe((mfaAuthCodeType: authenticationTypes.IMfaAuthCodeType) => {
          this.mfaAuthCodeType = mfaAuthCodeType;
        })
    );
    
    /*this.subscriptions.push(
      this.store.select(fromRoot.getApplicationPortalInformation)
        .subscribe((portalInfo: IPortalInfo) => {
          this.portalInfo = portalInfo;
        })
    );*/

  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  saveMFAType(mfaAuthTypeData): void {
    this.store.dispatch(new SaveMfaAuthTypeAction(mfaAuthTypeData));
  }

  authenticateMFA(mfaCredentials): void {
    this.store.dispatch(new ServerMfaLoginAction(mfaCredentials));
  }

  mailMFACode(): void {
    this.store.dispatch(new ResendMfaCodeAction({}));
  }



}



// WEBPACK FOOTER //
// ./src/app/authentication/containers/mfaauthentication-container/mfaauthentication-container.component.ts